<div *ngIf="propiedades != null" class="row row-cols-2 row-cols-md-3 g-4 mt-4">
  <div class="col" *ngFor="let propiedad of propiedades">
    <div class="card h-100 animated fadeIn fast imgRec left">

      <!-- Carrusel dentro del link -->
      <!-- <a [routerLink]="['/propiedad/', propiedad.id]" target="_blank"> -->
        <a [routerLink]="['/propiedad/', propiedad.id]" >
        <div id="carousel-{{propiedad.id}}"
             class="carousel slide"
             data-bs-ride="carousel"
             data-bs-interval="3000"
             data-bs-pause="hover">

          <div class="carousel-inner">
            <!-- Imágenes -->
            <div *ngFor="let img of propiedad.imagenes; let i = index"
                 class="carousel-item"
                 [class.active]="i === 0">
              <img [src]="img.thumbnail | noimage"
                   class="d-block w-100 img-fluid oscurecer"
                   alt="..." />
            </div>

            <!-- Caso sin imágenes -->
            <div *ngIf="propiedad.imagenes.length === 0" class="carousel-item active">
              <img [src]="'' | noimage"
                   class="d-block w-100 img-fluid oscurecer"
                   alt="..." />
            </div>
          </div>
        </div>
      </a>

      <!-- Contenido de la card -->
      <div class="card-body">
        <h5 class="card-title">
          <span *ngIf="propiedad.precio != 0" style="font-weight: 600 !important;">
            {{ propiedad.tipoMoneda.code === 'ARS' ? '$' : 'U$S' }}
            {{ propiedad.precio | number }}
          </span>
          <span *ngIf="propiedad.precio === 0" style="font-weight: 600 !important;">
            Consultar {{ propiedad.tipoMoneda.code === 'ARS' ? '$' : 'U$S' }}
          </span>
        </h5>
        <p class="card-text">
          <span>{{propiedad.tipoPropiedad.descripcion}}</span>
        </p>
        <p class="card-text">
          <span style="font-weight: 600 !important;">
            {{propiedad.domicilio.calle}} {{propiedad.domicilio.numero}}
          </span>
          <small class="text-muted">
            - {{propiedad.domicilio.barrio.localidad.descripcion}}
          </small>
        </p>
      </div>

      <!-- Etiqueta de operación -->
      <div class="TipoPunt">
        <a class="TipoPuntText ng-binding">
          {{propiedad.tipoOperacion.descripcion}}
        </a>
        <ng-container *ngFor="let item of propiedad.caracteristicasPropiedad">
          <div class="aptCr" *ngIf="item.code === 'APCRED'">
            <span class="aptCr-text">{{item.descripcion}}</span>
          </div>
        </ng-container>
      </div>

      <!-- Footer con íconos -->
      <div class="card-footer">
        <div class="row">
          <div class="cols-3 col"
               *ngFor="let item of propiedad.caracteristicasPropiedad"
               [innerHtml]="item | iconspipe">
          </div>

        </div>
      </div>

    </div>
  </div>
</div>
